module.exports = __webpack_public_path__ + "static/media/document.5b1396a7.svg";